import { MLP_ACTION_TYPES } from '../../actions/mlp/mlp_action';
import moment from 'moment';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    filters: {
        showFilters: false,
        customer: null,
        startDate: moment().startOf('year'),
        endDate: moment().endOf('year')
    },
    collection: [],
    totalValues: 0
};

export const mlps = (state = initialState, action) => {
    switch (action.type) {
        case MLP_ACTION_TYPES.GET_MLPS_SUCCESS:
            return { ...state, collection: action.payload };
        case MLP_ACTION_TYPES.GET_MLP_VALUES_SUCCESS:
            return { ...state, totalValues: action.payload };
        case MLP_ACTION_TYPES.POST_MLP_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case MLP_ACTION_TYPES.PUT_MLP_SUCCESS:
            const updatedMlp = action.payload;
            return { ...state, collection: state.collection.map((mlp) => mlp.uuid !== updatedMlp.uuid ? mlp : { ...mlp, ...updatedMlp }) };
        case MLP_ACTION_TYPES.UPDATE_MLPS_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
